import { ProductPricesSummary } from "../../shop/shared/models/product-card.model";
import { DEFAULT_PRODUCT_IMAGE } from "../../shop/shared/constants/products.constants";
import { TagDTO } from "app/shared/models/tag.models";
import { TagTypeEnum } from "app/shared/enums/tag-type.enum";
import { ProductListMediaDto } from "app/shared/models/media.models";
import { PaletteLimitDTO } from "app/shared/models/palette-limit.model";
import { OrderTypeEnum } from "app/shared/enums/order-type.enum.model";
import { GenderTypeEnum } from "app/back-office/shared/enum/gender-type.enum.model";

export class ProductListDto {
  code: string;
  extCode?: string;
  hasPromoByQuantity: boolean;
  hasPromoByValue: boolean;
  id: number;
  media: ProductListMediaDto;
  pricesSummary: ProductPricesSummary;
  productTags?: TagDTO[];
  title: string;
  variantTags?: TagDTO[];
  href?: string;
  isOpen?: boolean;
  paletteLimits: PaletteLimitDTO[];
  gender: GenderTypeEnum;
  styleGroupId: number;
  variantsTotalAvailableQuantity?: number;
  constructor(init?: Partial<ProductListDto>) {
    Object.assign(this, init);
  }
}

export class ProductLisMultiSelectVM extends ProductListDto {
  checked: boolean;
  mediaUrl: string;
  productName: string;
  constructor(init?: ProductLisMultiSelectVM) {
    super();
    Object.assign(this, init);
  }
}


export class ProductOverview extends ProductListDto {
  private _mockedLogoUrl: string;

  // getter and setter for logo Url
  get logoUrl(): string {
    if (this._mockedLogoUrl)
      return this._mockedLogoUrl;
    // if (this.mainMedia?.src)
    //   return this.mainMedia?.src;
    return DEFAULT_PRODUCT_IMAGE;
  }

  set logoUrl(value: string) {
    this._mockedLogoUrl = value;
  }


  constructor(s?: Partial<ProductOverview>, isPreOrder?: boolean) {
    super(s);
    if (s) {
      Object.assign(this, s);

      if (s.pricesSummary) {
        this.pricesSummary = new ProductPricesSummary(s.pricesSummary);
      }
      if (s.media) {
        this.media = new ProductListMediaDto(s.media);
      }

      if (s.productTags) {
        this.productTags = s.productTags.map(x => new TagDTO(x));
      }

      if (s.variantTags) {
        this.variantTags = s.variantTags.map(x => new TagDTO(x));
      }

      if (isPreOrder) {
        this.variantTags = (s.variantTags || this.variantTags || []).filter(x => x.type !== TagTypeEnum.StoreChannelDiscountVariantTag);
        this.productTags = (s.productTags || this.productTags || []).filter(x => x.type !== TagTypeEnum.StoreChannelDiscountVariantTag);
      } else {
        this.variantTags = (s.variantTags || this.variantTags || []).filter(x => x.type !== TagTypeEnum.VariantAvailableForCustomizationTag);
      }

      if (this.variantsTotalAvailableQuantity === null || this.variantsTotalAvailableQuantity === undefined) {
        this.variantsTotalAvailableQuantity = 0;
      }
    }
  }
}
